import React, { Component } from 'react';

class SelectedItemsIndicator extends Component {
    render() {
        const { selectedItems } = this.props;
        const label = selectedItems > 1 ? 'items' : 'item';
        return (
            <div className="ckp-admin-action-bar-selected-rows">
                {selectedItems} {label} selected
            </div>
        );
    }
}

export default SelectedItemsIndicator;
